import AbTestHttpService from '../AbTestHttpService';
import { isAA } from './AbExperimentsModal';

export class AbExperimentUI {
    constructor(experiment, parentElement) {
        this.experiment = experiment;
        this.parentElement = parentElement;

        this.modalMessageSelector = '.abtest__modal__message';
        this.modalMessageElement = null;

        this.$abTestHttpService = new AbTestHttpService({
            isAA: isAA(),
        });

        // render experiment data
        this.render();

        // get reference to modal message container
        this.modalMessageElement = document.querySelector(this.modalMessageSelector);
        this.modalMessageElement.innerHTML = '';
    }

    getXhrBadgeTemplate() {
        return this.experiment.isXHR ? `<span class="experiment__badge">XHR</span>` : '';
    }

    getOptimizelyTemplate() {
        return `<div class="experiment__block">
                    <span class="experiment__label">Optimizely Key:</span>
                    <span class="experiment__key">${this.experiment.experimentKey}</span>
                </div>`;
    }

    getActiveVariantTemplate() {
        return `<div class="experiment__block">
                    ${this.getActiveVariantChildTemplate() ?? 'DISABLED'}
                </div> `;
    }

    getActiveVariantChildTemplate() {
        return this.experiment.activeVariant
            ? `<span class="experiment__label">Active Variant: </span>
               <span class="experiment__active__variant">${this.experiment.activeVariant}</span>`
            : null;
    }

    getAvailableVariantsTemplate() {
        return `<div class="experiment__block">
                    ${this.getVariantsTemplate()}
                </div>`;
    }

    getVariantsTemplate() {
        return this.experiment.activeVariant
            ? `<div class="experiment__variants experiment__variants__${this.experiment.experimentKey}">
                    <span class="experiment__label">Switch Variant to: </span>
                </div>`
            : '';
    }

    render() {
        let temp = document.createElement('li');
        temp.innerHTML = `
            <div class="experiment__container ${this.experiment.isActive ? 'active' : 'disabled'}">
                <div class="experiment__header">
                    <span class="experiment__name">
                        ${this.formatExperimentName(this.experiment.name)}
                    </span>
                    ${this.getXhrBadgeTemplate()}                  
                </div>
                ${this.getOptimizelyTemplate()}
                ${this.getActiveVariantTemplate()}  
                ${this.getAvailableVariantsTemplate()}         
            </div>
        `;
        this.parentElement.appendChild(temp);
        this.appendVariants();
    }

    appendVariants() {
        let variantsContainer = this.parentElement.querySelector(
            `.experiment__variants__${this.experiment.experimentKey}`,
        );
        let activeVariant = this.experiment.activeVariant;
        let experimentKey = this.experiment.experimentKey;
        if (variantsContainer && this.experiment.activeVariant /* !== undefined*/) {
            this.experiment.variantsList.forEach((variantValue) => {
                let temp = document.createElement('li');
                let buttonLink = 'javascript:void(0)';
                let buttonClassList =
                    'button ' + (variantValue === activeVariant ? 'active' : 'secondary');
                let buttonCopy = variantValue;
                temp.innerHTML = this.renderButton(buttonLink, buttonClassList, buttonCopy);
                temp.addEventListener('click', (event) => {
                    // TODO: Paul's suggestion to attach AbTestHttpService to AbTest.js
                    // this.experiment.httpService.setVariantCookie().then((res)=>{
                    //     this.experiment.implemnt()
                    // })
                    this.updateExperimentVariantCookie(this.experiment.experimentKey, variantValue);
                });
                variantsContainer.appendChild(temp);
            });
        }
    }

    updateExperimentVariantCookie(test, variant) {
        this.modalMessageElement.classList.add('show');
        this.modalMessageElement.innerHTML = 'Trying to change your variant. Stand by...';

        this.$abTestHttpService
            .setVariantCookie(test, variant)
            .then((res) => {
                this.modalMessageElement.classList.remove('info');
                if (res.success) {
                    const url = new URL(window.location.href);
                    this.modalMessageElement.innerHTML = `Successfully updated <span>${test}</span> to variant <span>${variant}</span>. Reloading the page to take effect.`;
                    window.location.href = `${url.toString()}`;
                } else {
                    this.modalMessageElement.classList.add('error');
                    this.modalMessageElement.innerHTML =
                        'An error occurred updating the variant. Please try again';
                }
            })
            .catch((e) => {
                this.modalMessageElement.classList.add('error');
                this.modalMessageElement.innerHTML =
                    'An error occurred updating the variant. Please try again';
                console.error(`An error occurred updating the variant for ${test} -- ${e}`);
            });
    }

    /**
     * Adds space when uppercase is found
     * @param name
     */
    formatExperimentName(name) {
        return name?.replace(/((?<=[a-z])[A-Z]|[A-Z](?=[a-z]))/g, ' $1').replace('.js', '');
    }

    renderButton(buttonLink, buttonClassList, buttonCopy) {
        return `
            <button class="${buttonClassList}">
                <div class="button__text">
                    ${buttonCopy}
                </div>
            </button>
        `;
    }
}
